import { render, staticRenderFns } from "./doubleStar.vue?vue&type=template&id=52db24ef"
import script from "./doubleStar.vue?vue&type=script&lang=js"
export * from "./doubleStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports